export default __webpack_public_path__ + "static/icono_horizontal_articulos-6d2859b26f29614fda8a413326e44583.jpg";